import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-MetrikaShape",
  "use": "svg-icon-MetrikaShape-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-MetrikaShape\"><path d=\"M16.5 2v20h7V2h-7zM22 20.5h-4v-17h4v17zM.5 22h7v-9h-7v9zM2 14.5h4v6H2v-6zM8.5 22h7V8h-7v14zM10 9.5h4v11h-4v-11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol